<template>
  <div id="app">
    <transition :name="currentTransition">
        <div :is="component" :answer-name="currentAnswer" :answer-index="currentAnswerIndex" :plate-number="currentPlateNumber" @change-view="changeView"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: function() {
    return {
      viewName: 'HomeComponent',
      answerName: '',
      answerIndex: 0,
      plateNumber: 0,
      transitionName: 'right'
    }
  },
  computed: {
    component: function() {
      return this.viewName
    },
    currentAnswer: function() {
      return this.answerName
    },
    currentAnswerIndex: function() {
      return this.answerIndex
    },
    currentPlateNumber: function() {
      return this.plateNumber
    },
    currentTransition: function() {
      return this.transitionName
    }
  },
  localStorage: {
    customPlate: {
      type: String,
      default: ''
    }
  },
  created: function() {
    let custom = this.getParam('custom')
    if (custom) {
      this.setCustomPlate(custom)
    }
  },
  methods: {
    changeView: function({viewName, answerName='', answerIndex=0, plateNumber=0, transitionName='right'} = {}) {
      plateNumber = parseInt(plateNumber, 10)
      this.viewName = viewName
      this.answerName = answerName
      this.answerIndex = answerIndex
      this.plateNumber = plateNumber
      this.transitionName = transitionName
    }
  }
}
</script>
